/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-09-02 14:58:55
 **/
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import ReactQuill from "@rsupport/react-quill";
import type { Range } from "quill";
import Keys from "../keys";
import { useMemo } from "react";

type Options = Partial<{
	// Not now
}>;

export default function useChatKeyboardBinding(editor: ReactQuill | null, options: Options = {}) {
	return useMemo(() => {
		editor?.getEditor().keyboard.addBinding({ key: Keys.SINGLEQUOTE }, (range: Range, context: any) => {
			const _editor = editor?.getEditor();
			if (_editor) {
				const codeEditor = _editor.getText(range.index - 2, 2);
				if (codeEditor === "``") {
					_editor.deleteText(range.index - 2, 2);
					_editor.format("code-block", true);
					const nextIsEmpty = (_editor.getText(range.index, 1) || "").length <= 0;
					if (nextIsEmpty) {
						_editor.insertText(range.index - 1, "\n"); // code-block의 경우 다음 라인이 없을 때 해제하기 어려워 빈 라인을 하나 추가함
					}
					return;
				}
				const selection = _editor.getSelection(true);
				if (selection.length > 0) {
					_editor.formatText(selection, "code", {}, "api");
					_editor.setSelection(selection.index + selection.length, 0);
					return;
				} else {
					if (range.length === 0) {
						const line = _editor.getText(0, range.index);
						const index = line.lastIndexOf("`");
						if (index >= 0 && range.index - index !== 1) {
							_editor.deleteText(index, 1);
							_editor.removeFormat(index, range.index + index, "user");
							_editor.formatText(index, range.index - index - 1, "code", {}, "user");
							return;
						}
					}
				}
			}
			return true;
		});
		// editor?.getEditor().keyboard.addBinding({ key: Keys.BACKSPACE }, (range: Range, context: any) => {
		// 	// if (range.index === 0 && range.length === 0) {
		// 	// 	placeholder && fn.update_placeholder(placeholder);
		// 	// }
		// 	const text = editor?.getEditor().getText();
		// 	console.debug("Backspace", context.offset - 1, text);
		// 	editor?.getEditor().deleteText(range.index - 1, 1, "user");
		// });
	}, [editor]);
}
